<template lang="pug">
  div
    v-tooltip(left)
      v-btn(flat small icon color="app-edit" @click.stop="openDialog" class="ma-0" slot="activator")
        v-icon(v-if="viewOnly") assignment
        v-icon(v-else) fa-truck
      span(v-if="viewOnly") 配送情報
      span(v-else) 配送手続

    v-dialog(
      lazy
      persistent
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
    )

      v-card(v-if="one !== null")
        v-card-title.py-1.white--text(:class="viewOnly ? 'secondary' : 'app-edit'")
          span(v-if="viewOnly") 配送情報
          span(v-else) 配送手続
          v-spacer
          v-btn(flat small icon color="white" @click.stop="dialog = false")
            v-icon close

        v-card-text.pa-0
          v-layout(row wrap)
            v-flex(xs12 md8 offset-md2 lg6 offset-lg3)
              v-card(flat)
                v-card-title.secondary.white--text
                  span 注文内容
                v-card-text

                  ul.app-list-slim
                    li
                      ul(
                        v-for="item, index in row.order.items"
                        :key="index"
                      )
                        li.w70per
                          span.rem8 {{item.name}}
                        li.w10per.align-right
                          span {{item.price|number}}
                          span.rem9.grey--text.ml-2 円
                        li.w10per.align-right
                          span {{item.num|number}}
                          span.rem9.grey--text.ml-2 個
                        li.w10per.align-right
                          span {{item.sub_total|number}}
                          span.rem9.grey--text.ml-2 円

          v-layout(row wrap)
            v-flex(xs12 md2 offset-md2 lg2 offset-lg3)
                  div.app-line
                    span.app-line-title 小計
                    span.app-line-text {{row.order.summary.total|number}}
                    span.app-line-suffix 円

            v-flex(xs12 md3 lg2)
                  div.app-line
                    span.app-line-title 消費税 ( {{row.order.summary.tax_rate}} %)
                    span.app-line-text {{row.order.summary.tax|number}}
                    span.app-line-suffix 円

            v-flex(xs12 md3 lg2)
                  div.app-line
                    span.app-line-title 送料
                    span.app-line-text {{row.order.summary.delivery_fee|number}}
                    span.app-line-suffix 円

          v-layout(row wrap)
            v-flex(xs12 md3 offset-md4 lg2 offset-lg5)
                  div.app-line
                    span.app-line-title 代引手数料
                    span.app-line-text {{row.order.summary.cod_fee|number}}
                    span.app-line-suffix 円

            v-flex(xs12 md3 lg2)
                  div.app-line
                    span.app-line-title 合計金額
                    span.app-line-text {{row.order.summary.grand_total|number}}
                    span.app-line-suffix 円

          v-layout(row wrap)
            v-flex(xs12 md4 offset-md2 lg3 offset-lg3)
              v-card(flat)
                v-card-title.secondary.white--text
                  span 注文情報
                v-card-text
                  div.app-line
                    span.app-line-title 注文番号
                    span.app-line-text {{row.id}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 注文時刻
                    span.app-line-text {{row.order.summary.order_timestamp|date('YYYY/MM/DD HH:mm:ss')}}
                    span.app-line-suffix &nbsp;

                v-card-title.secondary.white--text
                  span 注文者情報
                v-card-text
                  div.app-line
                    span.app-line-title 注文者
                    span.app-line-text {{row.order.customer.name}}
                    span.app-line-suffix 様

                  div.app-line
                    span.app-line-title メールアドレス
                    span.app-line-text {{row.order.customer.email}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 電話番号
                    span.app-line-text {{row.order.customer.tel}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 郵便番号
                    span.app-line-text {{row.order.customer.zipcode}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 都道府県
                    span.app-line-text {{row.order.customer.pref}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 住所１
                    span.app-line-text {{row.order.customer.address1}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 住所２
                    span.app-line-text {{row.order.customer.address2}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 希望配送日
                    span.app-line-text {{row.order.customer.desired_delivery_date|date}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 希望配送時間帯
                    span.app-line-text {{row.order.customer.desired_delivery_time}}
                    span.app-line-suffix &nbsp;

            v-flex(xs12 md4 lg3 v-if="viewOnly")
              v-card(flat)
                v-card-title.secondary.white--text
                  span 配送情報
                v-card-text
                  div.app-line
                    span.app-line-title 問い合わせ番号
                    span.app-line-text {{row.shipment.no}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 配当予定日
                    span.app-line-text {{row.shipment.expected_delivery_date|date}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 配送予定時間帯
                    span.app-line-text {{row.shipment.expected_delivery_time}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 担当者
                    span.app-line-text {{row.shipment.inputter}}
                    span.app-line-suffix &nbsp;

                  div.app-line
                    span.app-line-title 配送入力時刻
                    span.app-line-text {{row.shipment.shipment_timestamp|date('YYYY/MM/DD HH:mm:ss')}}
                    span.app-line-suffix &nbsp;

                  v-textarea(
                    label="注文者へコメント"
                    class="input-group--focused"
                    color="black"
                    rows="5"
                    outline
                    :value="row.shipment.comment"
                    readonly
                  )

            v-flex(xs12 md4 lg3 v-else)
              v-card.elevation-8(raised)
                v-card-title.primary.white--text
                  span 配送情報
                v-card-text

                  v-text-field(
                    type="num"
                    label="問い合わせ番号"
                    v-model="one.shipment.no"
                    autocapitalize="off"
                    ref="shipment_no"
                    :rules="[rules.required,rules.integer]"
                    validate-on-blur
                    prepend-icon="location_on"
                  )

                  v-menu(
                    lazy
                    :close-on-content-click="false"
                    v-model="shipmentDatePicker"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    )
                    v-text-field(
                      label="配送予定日"
                      slot="activator"
                      :value="one.shipment.expected_delivery_date|date"
                      prepend-icon="fa-calendar"
                      ref="expected_delivery_date"
                      :rules="[rules.required]"
                      readonly
                      )
                    v-date-picker(
                      v-model="one.shipment.expected_delivery_date"
                      :allowed-dates="allowedDates"
                      )

                  v-select(
                    :items="selection.times"
                    label="配送予定時間帯"
                    v-model="one.shipment.expected_delivery_time"
                    ref="expected_delivery_time"
                    :rules="[rules.required]"
                    prepend-icon="fa-clock-o"
                    )

                  v-text-field(
                    type="text"
                    label="担当者"
                    v-model="one.shipment.inputter"
                    autocapitalize="off"
                    ref="shipment_inputter"
                    :rules="[rules.required]"
                    validate-on-blur
                    class="input-group--focused"
                    color="black"
                    readonly
                  )

                  v-textarea(
                    type="text"
                    label="注文者へコメント"
                    v-model="one.shipment.comment"
                    rows="5"
                    outline
                    autocapitalize="off"
                    validate-on-blur
                    hide-details
                  )

                  v-checkbox(
                    v-model="one.shipment.enable_notify"
                    raised
                    color="success"
                    label="メールを送信する"
                    hide-details
                  )
                  span.remarks 通常はチェックしてください。注文キャンセルや手動でメールを送信した場合に、チェックを外してください。

                  v-btn(
                    raised
                    color="success"
                    block
                    large
                    @click="save"
                    :disabled="exclusiveLock"
                  )
                    v-icon save
                    span(v-show="one.shipment.enable_notify") 登録 &amp; 配送情報メール送信
                    span(v-show="!one.shipment.enable_notify") 登録のみ

</template>

<script>
import { mapGetters } from 'vuex'
import rules from '@/common/mixins/rules'

export default {
  data () {
    return {
      dialog: false,
      one: null,
      shipmentDatePicker: false,
      selection: {
        times: [
          '午前中（12時まで）',
          '14:00〜16:00',
          '16:00〜18:00',
          '18:00〜20:00',
          '19:00〜21:00',
          '指定なし'
        ]
      },
      exclusiveLock: false
    }
  },
  props: {
    row: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [rules],
  watch: {
    dialog (val) {
      if (!val) {
        this.one = null
      }
    }
  },
  computed: {
    ...mapGetters('common/account', ['me'])
  },
  methods: {
    openDialog () {
      this.one = Object.assign(JSON.parse(JSON.stringify(this.row)), {
        shipment: {
          no: null,
          expected_delivery_date: null,
          expected_delivery_time: null,
          comment: '',
          inputter: this.me.name,
          enable_notify: true
        }
      })
      this.dialog = true
    },
    allowedDates (val) {
      return this.$moment().format('YYYY-MM-DD') <= val
      // return moment().format('YYYY-MM-DD') < val && _.contains([0, 6], moment(val).day())
    },
    save () {
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('common.rules.invalidate_message'))
        return true
      }
      if (this.exclusiveLock) {
        return
      }
      this.exclusiveLock = true
      // NOTE NOT id. send key is [key].
      this.$ajax
        .put(`/resources/shipments/${this.one.key}`, this.one.shipment)
        .then(response => {
          this.$toastr.success('配送登録が完了しました。')
          this.dialog = false
          this.$emit('complete')
        })
        .catch(error => {
          console.dir(error)
          this.$toastr.error(
            this.$t(error.response.data.translate_code) ||
              error.response.data.message
          )
        })
        .finally(() => {
          this.exclusiveLock = false
        })
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/pages/Staff/Dashboard/shipment.vue